<form (ngSubmit)="save()" [formGroup]="form">
    <div class="flex items-center" mat-dialog-title>
        <h2 class="headline m-0 flex-auto">{{data.title}}</h2>
        <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
            <mat-icon svgIcon="mat:close"></mat-icon>
        </button>
    </div>
    <mat-divider class="text-border"></mat-divider>
    <mat-dialog-content class="flex flex-col">
        <mat-form-field class="flex-auto">
            <mat-label>Titulo</mat-label>
            <input formControlName="titulo" matInput>
        </mat-form-field>
        <mat-form-field class="flex-auto">
            <mat-label>Mensaje</mat-label>            
            <textarea matInput formControlName="cuerpo" rows="5"></textarea>
        </mat-form-field>
        <mat-form-field class="flex-auto">
            <mat-label>URL</mat-label>            
            <input formControlName="url" matInput>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close type="button">{{appSettings.DIALOG_BUTTON_CANCEL}}</button>
        <!-- <button [disabled]="form.invalid" color="primary" mat-flat-button type="submit">{{data.button}}</button> -->
        <button color="primary" mat-flat-button type="submit">{{data.button}}</button>
    </mat-dialog-actions>
</form>